interface Domain {
  internal: Environment
  external: Environment
}

interface Environment {
  prod: string
  stage: string
}

export const api: Domain = {
  internal: {
    prod: 'https://api-internal.target.com/internal_app_analytics/v3',
    stage: 'https://stgapi-internal.target.com/internal_app_analytics/v3',
  },
  external: {
    prod: 'https://api.target.com/internal_app_analytics/v3',
    stage: 'https://stage-api.target.com/internal_app_analytics/v3',
  },
}

const defaultConfig = {
  api,
}
export default defaultConfig
